import { Link } from "eddev/routing"
import { motion } from "framer-motion"
import { useId } from "react"
import { twMerge } from "tailwind-merge"

type TabItem<T> = {
  label: string
  value: T
}

type Props<T> = {
  id?: string
  items: TabItem<T>[]
  value: string
  onValueChange: (value: T) => void
  textStyle?: string
  className?: string
  swapOrder?: boolean
}

export function Tabs<T extends string>(props: Props<T>) {
  const id = useId()

  let items = props.items

  if (props.swapOrder) {
    items = [items.find((item) => item.value === props.value), ...items.filter((item) => item.value !== props.value)].filter((item): item is TabItem<T> => !!item)
  }

  return (
    <motion.div layoutRoot className={twMerge("stack-x-5 border-b pb-4", props.className)}>
      {items.map((item, i) => (
        <motion.label
          key={item.value}
          layout
          layoutDependency={props.value}
          className={"cursor-pointer opacity-50 hover:opacity-60 has-[input:checked]:!opacity-100 transition-opacity inline-flex"}
        >
          <input
            type="radio"
            name={props.id ?? id}
            value={item.value}
            checked={props.value === item.value}
            onChange={(e) => {
              if (e.target.checked) {
                props.onValueChange(item.value)
              }
            }}
            className="sr-only"
          />
          <span className={props.textStyle ?? "type-title-l-medium leading-none"}>{item.label}</span>
        </motion.label>
      ))}
    </motion.div>
  )
}
